import React, { useEffect, useState } from "react";
import { Megaphone, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export function HomeBannerSettings() {
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/settings/home-banner").then((r) => setCfg(r.data)).catch(console.error); }, []);
  if (!cfg) return null;
  const upd = (k) => (e) => setCfg((c) => ({ ...c, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const save = async () => {
    try {
      const { data } = await api.put("/admin/settings/home-banner", { enabled: !!cfg.enabled, code: cfg.code, text: cfg.text, cta: cfg.cta });
      setCfg(data); toast.success("Bandeau enregistré ✓");
    } catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Erreur"); }
  };
  const inp = "bg-ink border border-zinc-700 px-3 py-2 text-white text-sm w-full focus:border-neon-green outline-none";
  return (
    <div data-testid="home-banner-settings" className="border border-zinc-800 bg-ink-surface mb-6">
      <button type="button" data-testid="home-banner-toggle" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-left gap-3">
        <span className="font-anton uppercase text-white flex items-center gap-2"><Megaphone className="h-4 w-4 text-neon-green" /> Bandeau promo page d'accueil</span>
        <span data-testid="home-banner-summary" className="text-zinc-500 text-xs text-right">{cfg.enabled ? `Code ${cfg.code}${cfg.code_valid ? "" : " (⚠️ code introuvable)"}` : "Désactivé"} {open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3">
          <p className="text-zinc-400 text-xs">Le code <span className="text-white">{cfg.code}</span> offre la livraison + <span className="text-white">{cfg.gift_label || "un cadeau"}</span>, 1 fois par numéro de téléphone (1ère commande). La remise livraison est absorbée par la maison mère ; le cadeau est à joindre par le livreur (ligne 🎁 sur la commande).</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label className="min-h-[44px] flex items-center gap-3 text-sm text-zinc-300 border border-zinc-800 px-3">
              <input data-testid="hb-enabled" type="checkbox" checked={!!cfg.enabled} onChange={upd("enabled")} className="accent-neon-green h-4 w-4" /> Bandeau affiché
            </label>
            <label className="text-xs text-zinc-400">Code promo affiché<input data-testid="hb-code" value={cfg.code} onChange={upd("code")} className={inp + " uppercase"} /></label>
            <label className="text-xs text-zinc-400 sm:col-span-2">Texte du bandeau<input data-testid="hb-text" value={cfg.text} onChange={upd("text")} maxLength={160} className={inp} /></label>
            <label className="text-xs text-zinc-400">Libellé du bouton<input data-testid="hb-cta" value={cfg.cta} onChange={upd("cta")} maxLength={40} className={inp} /></label>
          </div>
          <button data-testid="hb-save" onClick={save} className="w-full inline-flex items-center justify-center gap-2 bg-neon-green text-black font-anton uppercase px-4 py-2.5"><Save className="h-4 w-4" /> Enregistrer</button>
        </div>
      )}
    </div>
  );
}
